import { PageMeta } from '@shared';
import { t } from '@/i18n';

/**
 * TRAD-3720 — «없는 id · 불러오기 실패» 화면의 robots = noindex. NotFound 가 쓰던 PageMeta 를 그대로 뽑았다(같은 키 · 새 문구 0).
 * 콘텐츠 상세 경로는 이제 robots 없는 셸로 폴백하므로(scripts/lib/indexable-shell-routes.mjs), 상세 화면의 «찾을 수 없음»·에러 분기가
 * 이걸 그리지 않으면 robots 태그가 하나도 없는 soft 404 가 색인 후보가 된다 — 각 분기가 반드시 이걸 그린다.
 */
export const NotFoundMeta = () => (
  <PageMeta title={t('not_found.meta.title')} description={t('not_found.meta.description')} noIndex />
);
